
import LeaderboardRow from './LeaderboardRow.vue'
import { Article } from '../wikipedia'
import { RemoteData } from '../remoteData'
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  components: {
    LeaderboardRow,
  },
  props: {
    articles: {
      type: Object as PropType<RemoteData<Article[]>>,
      required: true,
    },
  },
})
